import React from 'react';

export default function() {
  return (
    <div className="loadingAnim">
      <div className="bullet"></div>
      <div className="bullet"></div>
      <div className="bullet"></div>
      <div className="bullet"></div>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Loading.js
 **/